<template>
  <a-card :bordered="false">
    <!--    <a-row style="position: absolute;top: -70px; width: calc(100% - 70px);" type="flex" justify="space-between" align="bottom">-->
    <!--      <a-col :span="12"></a-col>-->
    <!--      <a-col :span="12">-->
    <!--        <a-row type="flex" justify="center" style="box-sizing: border-box;">-->

    <!--          <a-col :span="7">-->
    <!--          </a-col>-->
    <!--          <a-col :span="6">-->
    <!--            <a-button  type="primary" @click="ExportTeam()">导出Excel</a-button>-->
    <!--          </a-col>-->
    <!--        </a-row>-->
    <!--      </a-col>-->
    <!--    </a-row>-->

    <div class="table-operator">
      <!--      <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新建</a-button>-->
      <a-dropdown v-if="removeEnable && selectedRowKeys.length > 0">
        <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
      </a-dropdown>
    </div>
    <div>
      <a-tabs defaultActiveKey="1" @change="callback">
        <a-tab-pane tab="库存记录" key="1">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" v-on:keyup.enter="$refs.table.refresh(true)">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="仓库名称">
                    <a-input v-model="queryParam.storeName" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="出库/入库">
                    <a-select v-model="queryParam.recordStatus" allowClear="true">
                      <a-select-option value="0">入库</a-select-option>
                      <a-select-option value="1">出库</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="仓库类型">
                    <a-select v-model="queryParam.storeType" allowClear="true">
                      <a-select-option value="0">主仓库</a-select-option>
                      <a-select-option value="1">机构分库</a-select-option>
                      <a-select-option value="2">师傅分库</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="配件类型">
                    <a-select
                      v-model="queryParam.accessoryType"
                      :allowClear="true"
                      showSearch
                      optionFilterProp="children"
                      :filterOption="filterOption"
                    >
                      <a-select-option v-for="type in dataType" :title="type.accessoryType" :key="type.accessoryType">
                        {{ type.accessoryType }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="配件名称">
                    <a-select
                      v-model="queryParam.accessoryName"
                      :allowClear="true"
                      showSearch
                      optionFilterProp="children"
                      :filterOption="filterOption"
                    >
                      <a-select-option v-for="type in dataName" :title="type.accessoryName" :key="type.accessoryName">
                        {{ type.accessoryName }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="配件型号" style="margin-left: 7px">
                    <a-select
                      v-model="queryParam.accessoryCategory"
                      :allowClear="true"
                      showSearch
                      optionFilterProp="children"
                      :filterOption="filterOption"
                    >
                      <a-select-option
                        v-for="type in dataCategory"
                        :title="type.accessoryCategory"
                        :key="type.accessoryCategory"
                        >{{ type.accessoryCategory }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="配件规格">
                    <a-select
                      v-model="queryParam.accessorySpecification"
                      :allowClear="true"
                      showSearch
                      optionFilterProp="children"
                      :filterOption="filterOption"
                    >
                      <a-select-option
                        v-for="type in dataSpecification"
                        :title="type.accessorySpecification"
                        :key="type.accessorySpecification"
                        >{{ type.accessorySpecification }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="产品类别">
                    <a-select
                      showSearch
                      optionFilterProp="children"
                      @change="handleChange"
                      v-model="queryParam.installType"
                      :filterOption="filterOption"
                      allowClear="true"
                    >
                      <a-select-option v-for="type in restaurantTypes2" :title="type.label" v-bind:value="type.code">
                        {{ type.label }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="操作人" style="margin-left: 14px">
                    <a-input v-model="queryParam.createBy" />
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="操作日期" style="margin-left: 7px">
                    <a-date-picker @change="onChangeDate2" format="YYYY-MM-DD" v-model="timess" style="width:100%" />
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="所在地址">
                    <a-col :span="12">
                      <a-select
                        v-model="queryParam.useProvince"
                        @change="onchange2"
                        :allowClear="true"
                        showSearch
                        optionFilterProp="children"
                        :filterOption="filterOption"
                      >
                        <a-select-option
                          v-for="type in selectAllProvince2"
                          :title="type.provinceName"
                          :key="type.provinceCode"
                          >{{ type.provinceName }}</a-select-option
                        >
                      </a-select>
                    </a-col>
                    <a-col :span="12">
                      <a-select
                        v-model="queryParam.useCity"
                        @change="onchange3"
                        :allowClear="true"
                        showSearch
                        optionFilterProp="children"
                        :filterOption="filterOption"
                      >
                        <a-select-option v-for="type in selectCityName2" :title="type.cityName" :key="type.cityCode">
                          {{ type.cityName }}</a-select-option
                        >
                      </a-select>
                    </a-col>
                  </a-form-item>
                </a-col>

                <a-col style="float: right;margin-right: 14px">
                  <a-button type="primary" style="margin-right: 8px" @click="$refs.table.refresh(true)">查询</a-button>
                  <a-button style="margin-right: 8px" @click="handleClear">清空</a-button>
                  <a-button type="primary" @click="ExportTeam()">导出Excel</a-button>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <s-table
            size="default"
            ref="table"
            rowKey="purchaseOrderId"
            :columns="columns"
            :data="loadData"
            :scroll="{ x: '2000px' }"
            bordered
          >
            <span slot="action" slot-scope="text, record">
              <a @click="detailBtn(record.accessoryId)" v-if="removeEnable">详情</a>
              <a-divider type="vertical" v-if="removeEnable && record.stores[0].storeName != '主仓库'" />
              <a v-if="removeEnable && record.stores[0].storeName != '主仓库'" @click="detailBtn2(record.storeId)"
                >服务区域</a
              >
            </span>

            <span slot="storeType" slot-scope="text, record">
              <a-text v-if="record.storeType == 0">主库 </a-text>
              <a-text v-else-if="record.storeType == 1">机构分库</a-text>
              <a-text v-else-if="record.storeType == 2">师傅分库</a-text>
            </span>

            <span slot="recordStatus" slot-scope="text, record">
              <a-text v-if="record.recordStatus == 0">入库 </a-text>
              <a-text v-else-if="record.recordStatus == 1">出库</a-text>
            </span>
          </s-table>
        </a-tab-pane>
        <a-tab-pane tab="使用记录" key="2">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" v-on:keyup.enter="$refs.table2.refresh(true)">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="仓库名称">
                    <a-input v-model="queryParam2.storeName" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="出库/入库">
                    <a-select v-model="queryParam2.recordStatus" allowClear="true">
                      <a-select-option value="0">入库</a-select-option>
                      <a-select-option value="1">出库</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="仓库类型">
                    <a-select
                      showSearch
                      optionFilterProp="children"
                      @change="handleChange"
                      v-model="queryParam2.storeType"
                      :filterOption="filterOption"
                      allowClear="true"
                    >
                      <a-select-option value="0">主仓库</a-select-option>
                      <a-select-option value="1">机构分库</a-select-option>
                      <a-select-option value="2">师傅分库</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="配件类型">
                    <a-select
                      v-model="queryParam2.accessoryType"
                      :allowClear="true"
                      showSearch
                      optionFilterProp="children"
                      :filterOption="filterOption"
                    >
                      <a-select-option v-for="type in dataType" :title="type.accessoryType" :key="type.accessoryType">
                        {{ type.accessoryType }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="配件名称">
                    <a-select
                      v-model="queryParam2.accessoryName"
                      :allowClear="true"
                      showSearch
                      optionFilterProp="children"
                      :filterOption="filterOption"
                    >
                      <a-select-option v-for="type in dataName" :title="type.accessoryName" :key="type.accessoryName">
                        {{ type.accessoryName }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="配件型号" style="margin-left: 7px">
                    <a-select
                      v-model="queryParam2.accessoryCategory"
                      :allowClear="true"
                      showSearch
                      optionFilterProp="children"
                      :filterOption="filterOption"
                    >
                      <a-select-option
                        v-for="type in dataCategory"
                        :title="type.accessoryCategory"
                        :key="type.accessoryCategory"
                        >{{ type.accessoryCategory }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="配件规格">
                    <a-select
                      v-model="queryParam2.accessorySpecification"
                      :allowClear="true"
                      showSearch
                      optionFilterProp="children"
                      :filterOption="filterOption"
                    >
                      <a-select-option
                        v-for="type in dataSpecification"
                        :title="type.accessorySpecification"
                        :key="type.accessorySpecification"
                        >{{ type.accessorySpecification }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="产品类别">
                    <a-select
                      showSearch
                      optionFilterProp="children"
                      @change="handleChange"
                      v-model="queryParam2.installType"
                      :filterOption="filterOption"
                      allowClear="true"
                    >
                      <a-select-option v-for="type in restaurantTypes2" :title="type.label" v-bind:value="type.code">
                        {{ type.label }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="操作人" style="margin-left: 14px">
                    <a-input v-model="queryParam2.createBy" />
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="操作日期" style="margin-left: 7px">
                    <a-date-picker @change="onChangeDate3" format="YYYY-MM-DD" v-model="timesss" />
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="使用地址">
                    <a-col :span="12">
                      <a-select
                        v-model="queryParam2.useProvince"
                        @change="onchange2"
                        :allowClear="true"
                        showSearch
                        optionFilterProp="children"
                        :filterOption="filterOption"
                      >
                        <a-select-option
                          v-for="type in selectAllProvince2"
                          :title="type.provinceName"
                          :key="type.provinceCode"
                          >{{ type.provinceName }}</a-select-option
                        >
                      </a-select>
                    </a-col>
                    <a-col :span="12">
                      <a-select
                        v-model="queryParam2.useCity"
                        @change="onchange3"
                        :allowClear="true"
                        showSearch
                        optionFilterProp="children"
                        :filterOption="filterOption"
                      >
                        <a-select-option v-for="type in selectCityName2" :title="type.cityName" :key="type.cityCode">
                          {{ type.cityName }}</a-select-option
                        >
                      </a-select>
                    </a-col>
                  </a-form-item>
                </a-col>
                <a-col style="float: right;margin-right: 14px">
                  <a-button type="primary" style="margin-right: 8px" @click="$refs.table2.refresh(true)">查询</a-button>
                  <a-button style="margin-right: 8px" @click="handleClear2">清空</a-button>
                  <a-button type="primary" @click="ExportTeam()">导出Excel</a-button>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <s-table
            size="default"
            ref="table2"
            rowKey="storeId"
            :columns="columns2"
            :data="loadData2"
            :scroll="{ x: '2000px' }"
            bordered
          >
            <!-- 服务类别-->
            <span slot="installTypes" slot-scope="text, record">
              <a-popover>
                <template slot="content">
                  <p v-for="item in record.installTypes">{{ item }}</p>
                </template>
                <span class="hover">{{ text }} </span>
              </a-popover>
            </span>

            <span slot="action" slot-scope="text, record">
              <a-divider type="vertical" v-if="removeEnable" />
              <a v-if="removeEnable" @click="detailBtn(record.accessoryId)">详情</a>
              <a-divider type="vertical" />
              <a v-if="removeEnable" @click="detailBtn2(record.storeId)">服务区域</a>
            </span>
          </s-table>
        </a-tab-pane>
      </a-tabs>
    </div>

    <storageRecord-modal ref="modal" @ok="handleOk" />

    <a-modal
      title="详情"
      style="top: 20px;"
      :width="1000"
      v-model="dateMode"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
    >
      <!--      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件类型">-->
      <!--        <a-input v-model="configure.accessoryType" disabled="disabled"/>-->
      <!--      </a-form-item>-->

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件名称">
        <a-input v-model="configure2.accessoryName" disabled="disabled" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件型号">
        <a-input v-model="configure2.accessoryCategory" disabled="disabled" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">
        <a-select
          disabled="disabled"
          v-model="accessoryInstallTypesList"
          mode="tags"
          :size="size"
          style="width: 200px"
          @change="handleChange3"
        >
          <a-select-option v-for="type in restaurantTypes2" :key="type.code">
            {{ type.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!--      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="">-->
      <!--        <a-select-->
      <!--          v-modle="accessoryInstallTypes"-->
      <!--          mode="tags"-->
      <!--          :size="size"-->
      <!--          style="width: 200px"-->
      <!--          disabled="disabled"-->
      <!--        >-->
      <!--          <a-select-option v-for="i in restaurantTypes" :key="i.key">-->
      <!--            {{ i.value }}-->
      <!--          </a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-form-item>-->

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件规格">
        <a-input v-model="configure2.accessorySpecification" disabled="disabled" />
      </a-form-item>
    </a-modal>

    <a-modal
      title="服务区域"
      style="top: 20px;"
      :width="1000"
      v-model="dateMode2"
      :confirmLoading="confirmLoading2"
      @ok="handleSubmit2"
    >
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所在省">
        <a-select v-model="selectAllProvince3" mode="tags" :size="size" style="width: 200px" disabled="disabled">
          <a-select-option v-for="i in selectAllProvince2" :key="i.provinceCode">
            {{ i.provinceName }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所在市">
        <a-select v-model="serviceCityList2" mode="tags" :size="size" style="width: 200px" disabled="disabled">
          <a-select-option v-for="i in selectCityName2" :key="i.cityCode">
            {{ i.cityName }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import {
  storageRecordExport2,
  useRecordExport,
  selectCityName,
  provinceCodeList,
  selectAllProvince,
  area,
  getoneaccessory,
  storagerecordlis,
  delStorageRecord,
  userecordlist
} from '@/api/accessory/storageRecord'
import {
  selectAccessorySpecification,
  selectAccessoryCategory,
  selectAccessoryName,
  selectAccessoryType
} from '@/api/accessory/supplier'

import storageRecordModal from './modules/storageRecordModal.vue'
import { checkPermission } from '@/utils/permissions'
import moment from 'moment'
import { getDictMap } from '../../utils/dict'
import { storageRecordExport } from '../../api/accessory/storageRecord'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'TableList',
  components: {
    STable,
    storageRecordModal
  },
  data() {
    return {
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      timesss: '',
      timess: '',
      keys: 1,
      accessoryInstallTypesList: '',
      accessoryName: '',
      modelAccessories: '',
      modelAccessories2: '',
      // 获取的市
      selectCityName2: '',
      //市
      serviceCityList2: '',
      // 获取的省
      selectAllProvince3: '',
      //省
      selectAllProvince2: '',
      dateMode2: false,
      configure: '',
      configure2: '',
      dateMode: false,
      socket: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      queryParam2: {},
      // 表头

      columns: [
        {
          title: '序号',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '操作',
          width: '80px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '操作人',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '操作时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        // {
        //   title: '库存记录id ',
        //   dataIndex: 'storageRecordId'
        // },
        {
          title: '所在城市',
          dataIndex: 'useCity',
          align: 'center'
        },
        // {
        //   title: '配件ID ',
        //   dataIndex: 'accessoryId'
        // },
        {
          title: '配件数量',
          dataIndex: 'accessoryNumber',
          align: 'center'
        },
        {
          title: '企业配件单价',
          dataIndex: 'unityPrice',
          align: 'center'
        },
        {
          title: '师傅配件单价',
          dataIndex: 'masterUnityPrice',
          align: 'center'
        },
        {
          title: '出入类型',
          dataIndex: 'recordStatus',
          align: 'center',
          scopedSlots: { customRender: 'recordStatus' }
        },
        // {
        //   title: '配件ID',
        //   dataIndex: 'accessories[0].accessoryId'
        // },

        {
          title: '配件类型 ',
          dataIndex: 'accessories[0].accessoryType',
          align: 'center'
        },
        {
          title: '配件名称',
          dataIndex: 'accessories[0].accessoryName',
          align: 'center'
        },
        {
          title: '   配件型号  ',
          dataIndex: 'accessories[0].accessoryCategory',
          align: 'center'
        },
        {
          title: '   配件规格  ',
          dataIndex: 'accessories[0].accessorySpecification',
          align: 'center'
        },
        {
          title: '   仓库名称   ',
          dataIndex: 'stores[0].storeName',
          align: 'center'
        },

        {
          title: '仓库类型 ',
          dataIndex: 'stores[0].storeType',
          align: 'center'
        }
      ],

      columns2: [
        {
          title: '序号',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '操作',
          width: '80px',
          dataIndex: 'action',

          scopedSlots: { customRender: 'action' }
        },
        {
          title: '操作人',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '操作时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        // {
        //   title: '库存记录id ',
        //   dataIndex: 'useRecordId'
        // },
        //  {
        //   title: '服务类别',
        //   dataIndex: 'installTypes[0]',
        //    align:'center',
        //    scopedSlots: { customRender: 'installTypes' }
        // },
        {
          title: '仓库名称',
          dataIndex: 'storeName',
          align: 'center'
        },

        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '配件名称',
          dataIndex: 'accessoryName',
          align: 'center'
        },
        {
          title: '配件类型 ',
          dataIndex: 'accessoryType',
          align: 'center'
        },
        {
          title: '   配件型号  ',
          dataIndex: 'accessoryCategory',
          align: 'center'
        },
        {
          title: '   配件规格  ',
          dataIndex: 'accessorySpecification',
          align: 'center'
        },
        {
          title: '   仓库类别  ',
          dataIndex: 'storeType',
          align: 'center'
        },

        {
          title: '订单号 ',
          dataIndex: 'storeNo',
          align: 'center'
        },

        {
          title: '客户名称 ',
          dataIndex: 'costmName',
          align: 'center'
        },
        {
          title: '客户手机号',
          dataIndex: 'costmPhone',
          align: 'center'
        },
        {
          title: '城市名称 ',
          dataIndex: 'useCityName',
          align: 'center'
        },

        {
          title: '   配件数量   ',
          dataIndex: 'accessoryNumber',
          align: 'center'
        },
        {
          title: '   企业配件单价  ',
          dataIndex: 'unityPrice',
          align: 'center'
        },
        {
          title: '   师傅配件单价  ',
          dataIndex: 'masterUnityPrice',
          align: 'center'
        },
        {
          title: '   企业配件总价   ',
          dataIndex: 'totalPrice',
          align: 'center'
        },
        {
          title: '   师傅配件总价   ',
          dataIndex: 'masterTotalPrice',
          align: 'center'
        },
        // {
        //   title: ' 订单id ',
        //   dataIndex: 'orderId',
        //   align:'center'
        // },
        {
          title: '出入库状态 ',
          dataIndex: 'recordStatus',
          align: 'center'
        }
      ],
      // 加载数据方法 必须为 Promise 对象

      loadData2: parameter => {
        return userecordlist(Object.assign(parameter, this.queryParam2))
      },
      loadData: parameter => {
        return storagerecordlis(Object.assign(parameter, this.queryParam))
      },

      selectedRowKeys: [],
      selectedRows: [],
      restaurantTypes: [],
      restaurantTypes2: [],
      addEnable: checkPermission('stock:storageRecord:add'),
      editEnabel: checkPermission('stock:storageRecord:edit'),
      removeEnable: checkPermission('removeEnable')
    }
  },
  filters: {},
  async created() {
    // 配件规格
    selectAccessorySpecification().then(res => {
      console.log(res)
      this.dataSpecification = res.rows
    })

    // 配件型号
    selectAccessoryCategory().then(res => {
      console.log(res)
      this.dataCategory = res.rows
    })

    // 配件名称
    selectAccessoryName().then(res => {
      console.log(res)
      this.dataName = res.rows
    })

    // 配件类型
    selectAccessoryType().then(res => {
      console.log(res)
      this.dataType = res.rows
    })

    document.body.addEventListener('keyup', e => {
      if (e.keyCode == 13) {
        this.$refs.table.refresh(true)
      }
    })

    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('delivery_company')
    this.restaurantOperTypeMap.forEach((value, key) => {
      this.restaurantTypes.push({ code: key, label: value })
    })

    this.restaurantTypes2 = []
    this.restaurantOperTypeMap2 = await getDictMap('install_type')
    this.restaurantOperTypeMap2.forEach((value, key) => {
      this.restaurantTypes2.push({ code: key, label: value })
    })

    selectAllProvince().then(res => {
      console.log(res)
      this.selectAllProvince2 = res.rows
    })
  },
  methods: {
    handleClear() {
      this.queryParam = {}
      this.timess = ''
    },

    handleClear2() {
      this.queryParam2 = {}
      this.timesss = ''
    },
    ExportTeam() {
      if (this.keys == 2) {
        var str = process.env.VUE_APP_API_BASE_URL + '/stock/useRecord/useRecordExport?pageNum=1&pageSize=10'
        for (let i in this.queryParam2) {
          if (this.queryParam2[i] != undefined) {
            str = str + '&' + i + '=' + this.queryParam2[i]
          }
        }
        str = str + '&token=' + this.headers.token
        window.open(str)
        // useRecordExport(this.queryParam2).then(res=>{
        //   console.log(res)
        //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
        //   const a = document.createElement('a')
        //   // 生成文件路径
        //   let href = window.URL.createObjectURL(blob)
        //   a.href = href
        //   let fileName = '使用记录'
        //   // 文件名中有中文 则对文件名进行转码
        //   a.download = decodeURIComponent(fileName)
        //   // 利用a标签做下载
        //   document.body.appendChild(a)
        //   a.click()
        //   document.body.removeChild(a)
        //   window.URL.revokeObjectURL(href)
        // })
      } else {
        var str = process.env.VUE_APP_API_BASE_URL + '/stock/record/storageRecordExport?pageNum=1&pageSize=10'
        for (let i in this.queryParam) {
          if (this.queryParam[i] != undefined) {
            str = str + '&' + i + '=' + this.queryParam[i]
          }
        }
        str = str + '&token=' + this.headers.token
        window.open(str)

        // storageRecordExport2(this.queryParam).then(res=>{
        //   console.log(res)
        //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
        //   const a = document.createElement('a')
        //   // 生成文件路径
        //   let href = window.URL.createObjectURL(blob)
        //   a.href = href
        //   let fileName = '库存记录'
        //   // 文件名中有中文 则对文件名进行转码
        //   a.download = decodeURIComponent(fileName)
        //   // 利用a标签做下载
        //   document.body.appendChild(a)
        //   a.click()
        //   document.body.removeChild(a)
        //   window.URL.revokeObjectURL(href)
        // })
      }
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    // 获取省
    onchange2(checkedValues) {
      console.log('enterprise = ', checkedValues)
      var array1 = checkedValues
      this.modelAccessories = array1.slice()
      console.log(this.modelAccessories)
      selectCityName({ provinceCode: this.modelAccessories }).then(res => {
        console.log(res)
        this.selectCityName2 = res.rows
      })
    },

    // 获取市
    onchange3(checkedValues) {
      console.log('enterprise = ', checkedValues)
      var array1 = checkedValues
      this.modelAccessories2 = array1.slice()
      console.log(this.modelAccessories2)
    },

    handleSubmit2() {
      this.dateMode2 = false
    },
    // 服务区域
    detailBtn2(storeId) {
      console.log(storeId)
      this.dateMode2 = true
      const store = {
        storeId: storeId
      }
      area(store).then(res => {
        console.log(res)
        this.configure = res.data
        this.selectAllProvince3 = res.data.serviceProvinceList
        this.serviceCityList2 = res.data.serviceCityList
        console.log(this.serviceCityList2)
        provinceCodeList({ provinceCodeList: this.selectAllProvince3.join(',') }).then(res => {
          console.log(res)
          let rows = res
          let result = []
          for (let i = 0; i < rows.length; i++) {
            console.log(rows[i])
            result = result.concat(rows[i])
          }
          this.selectCityName2 = result
          console.log(this.selectCityName2)
        })
      })
    },
    // 详情
    detailBtn(accessoryId) {
      this.dateMode = true
      console.log(accessoryId)
      const accessory = {
        accessoryId: accessoryId
      }
      getoneaccessory(accessory).then(res => {
        console.log(res)
        this.configure2 = res.data
        this.accessoryInstallTypesList = res.data.accessoryInstallTypesList
      })
    },

    handleSubmit() {
      this.dateMode = false
    },

    onChangeDate2(date, dateString) {
      this.queryParam.createTime = dateString
    },

    onChangeDate3(date, dateString) {
      this.queryParam2.createTime = dateString
    },

    callback(key) {
      console.log(key)
      this.keys = key
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    handleEdit(record) {
      this.$refs.modal.edit(record)
    },
    handleOk() {
      this.$refs.table.refresh(true)

      console.log('handleSaveOk')
    },
    delByIds(ids) {
      delstorageRecord({ ids: ids.join(',') }).then(res => {
        if (res.code === 0) {
          this.$message.success('删除成功')
          // this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
        this.selectedRowKeys = []
      })
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
